// Importing asks to save the mapping (ruled 2026-10-12, 61.93): the person
// maps in the table and presses Import, so a Save control on the way was
// missed and the mapping drawn was lost. The press opens this: save under
// a name and import, import without saving, or cancel.
import { useState } from 'react';
import { Modal } from '@/components/ui/Modal';
import { Button } from '@/components/ui/Button';
import { fieldClass } from '@/components/ui/field';

export function SaveMappingModal({
  name,
  applied,
  columns,
  relationships,
  busy = false,
  onSaveAndImport,
  onImportOnly,
  onCancel,
}: {
  /** The name proposed: the saved mapping's, or the file's. */
  name: string;
  /** The saved mapping the pages started from, when there is one. */
  applied: string | null;
  columns: number;
  relationships: number;
  busy?: boolean;
  onSaveAndImport: (name: string) => void;
  onImportOnly: () => void;
  onCancel: () => void;
}) {
  const [typed, setTyped] = useState(name);
  const chosen = typed.trim();
  return (
    <Modal
      title="Save this mapping?"
      titleId="save-mapping-title"
      onClose={onCancel}
      busy={busy}
      size="md"
      footer={
        <>
          <Button type="button" variant="ghost" size="md" onClick={onCancel} disabled={busy}>
            Cancel
          </Button>
          <Button type="button" variant="secondary" size="md" onClick={onImportOnly} disabled={busy}>
            Import without saving
          </Button>
          <Button
            type="button"
            variant="primary"
            size="md"
            onClick={() => onSaveAndImport(chosen)}
            disabled={busy || chosen === ''}
          >
            Save and import
          </Button>
        </>
      }
    >
      <p className="text-sm">
        {applied
          ? `The mapping on the pages differs from the saved mapping ${applied}. Save it so the next file with these columns gets it; the same name replaces that mapping.`
          : 'This mapping is not saved. Save it so the next file with these columns gets it automatically.'}
      </p>
      <p className="mt-1 text-xs text-muted-foreground">
        {columns} column{columns === 1 ? '' : 's'} and {relationships} ObjectPropert{relationships === 1 ? 'y' : 'ies'}.
      </p>
      <label className="mt-4 block text-sm">
        <span className="font-medium">Save as</span>
        <input
          type="text"
          value={typed}
          onChange={(e) => setTyped(e.target.value)}
          maxLength={120}
          autoFocus
          aria-label="Mapping name"
          className={fieldClass(chosen === '' ? 'error' : 'normal', 'mt-1 w-full text-sm')}
        />
        {chosen === '' && <span className="text-xs text-tres-error">A saved mapping needs a name.</span>}
      </label>
    </Modal>
  );
}
